<template lang="pug">
table.table-base.text-large.line-height-thin
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

/**
 * テーブルタグ
 */
@Component
export default class TableBase extends Vue {}
</script>

<style lang="stylus" scoped>
.table-base
  border-collapse collapse
</style>
